export default __webpack_public_path__ + "static/media/aleth_saddle.1bc5db4f.png";